import { DataType } from "@/types"
import { CaseColumn } from "@/types/caseColumns"
import { FieldTypeId } from "@/types/fieldTypes"
import { Insight, InsightDetails } from "@/types/insights"

export function getCalculationColumnAsCaseColumn (calculationColumnKey: string, calculationColumnTitle: string) {
	return {
		key: calculationColumnKey,
		dataType: FieldTypeId.Number,
		fieldDataType: DataType.number,
		label: calculationColumnTitle,
		dynamicField: true
	} as CaseColumn
}

export function getCalculationAsCaseColumn (calculationKey: string, calculationTitle: string) {
	return {
		key: calculationKey.startsWith("calculation") ? calculationKey : "calculation." + calculationKey,
		dataType: FieldTypeId.Number,
		fieldDataType: DataType.number,
		label: calculationTitle,
		dynamicField: false
	} as CaseColumn
}

export function getCalculationTotalAsCaseColumn (calculationTotalKey: string, calculationTotalTitle: string) {
	return {
		key: calculationTotalKey.startsWith("calculationTotal") ? calculationTotalKey : "calculationTotal." + calculationTotalKey,
		dataType: FieldTypeId.Number,
		fieldDataType: DataType.number,
		label: calculationTotalTitle,
		dynamicField: false
	} as CaseColumn
}

/**
 * Clears all Calculations and Calculation Totals from the given Insight.
 * Does not affect Calculation Columns.
 * @param insight The Insight to clear calculations from.
 */
export function clearCalculations (insight: Insight | InsightDetails): void {
	if (!insight) {
		return
	}

	insight.calculations = []
	insight.calculationTotals = []
	insight.includeCalculationsFrom = []
	insight.calculationSort = null
}

/**
 * Clears the Group By settings from the given Insight.
 * @param insight The Insight to clear Group By from.
 */
export function clearGroupBy (insight: Insight | InsightDetails): void {
	if (!insight) {
		return
	}

	insight.groupBy = null
	insight.groupByDataType = null
	insight.groupByOption = null
	insight.groupByLabel = null
	insight.groupByDateFormat = null

	// Properties only on InsightDetails
	if ("groupByApplyFilters" in insight) {
		insight.groupByApplyFilters = undefined
	}
}

/**
 * Clears the preset and preset parameters from the given Insight.
 * @param insight The Insight to clear the preset from.
 */
export function clearPreset (insight: Insight): void {
	insight.presetKey = null
	insight.presetParameters = {}
}

export function isUsingPreset (insight: InsightDetails): boolean {
	return !!insight.presetKey
}
